module.exports = __webpack_public_path__ + "img/com.Electrolux.PUREi9.ad6274e2.webp";